import {Component, HostListener, OnInit} from '@angular/core';
import {Meta, Title} from "@angular/platform-browser";
import {Router} from "@angular/router";

@Component({
  selector: 'app-aarni-school-of-business-management-and-commerce',
  templateUrl: './aarni-school-of-business-management-and-commerce.component.html',
  styleUrls: ['./aarni-school-of-business-management-and-commerce.component.scss']
})
export class AarniSchoolOfBusinessManagementAndCommerceComponent implements OnInit {
    index = 0;
    testimonialSlideIndex: number = 0;
    testimonialSlidesCount: number = 3;
    groupedTestimonials: any[][] = [];
    currentIndex = 0;
    translateX = 0;
    events = [
        {
            image: 'assets/img/home-page-events/event-home-page.jpg',
            date: '20 June 2024',
            title: 'Our Respected Chancellor met with Mr. Sudhir Chaudhary (Journalist at DD News)',
            description: 'To exchange insightful ideas and perspectives, our honorable Chancellor had the privilege to meet Mr. Sudhir Chaudhary, esteemed journalist at DD News.'
        },
        {
            image: 'assets/img/home-page-events/image-1.webp',
            date: '15 Oct 2024',
            title: 'Miss-Himachal 2021-2022 in Partnership with Godrej No. 1',
            description: 'ARNI University proudly hosted Miss Himachal 2021-2022 in partnership with Godrej No.1 on 15 Oct 2024 — celebrating talent, confidence, and culture.'
        },
        {
            image: 'assets/img/home-page-events/image-2.webp',
            date: '26 Jan 2024',
            title: 'Republic Day Celebration',
            description: 'ARNI University proudly celebrated Republic Day with a spirited NCC march, showcasing patriotism, discipline, and national pride on campus.'
        },
        {
            image: 'assets/img/home-page-events/image-3.webp',
            date: '19 Oct 2024',
            title: 'Special Convocational Ceremony',
            description: 'At ARNI University on February 1, to confer an honorary doctorate on Maj Gen Abhay Dayal, VSM for his immense contributions to the field of National Security (Army).'
        }
    ];
    testimonials = [
    /*    {
            name: 'Hem Raj',
            course: 'MBA',
            company: '',
            image: 'https://randomuser.me/api/portraits/men/42.jpg',
            feedback: `Studying business management at ARNI University has been a game-changer for me. I have learned from one of the best professors, and they were incredibly supportive. The course curriculum was industry-oriented with the latest market trends. The real-world exposure and workshops enhanced my confidence.`,
        },*/
        {
            name: 'Bhawna',
            course: 'MBA',
            company: '',
            image: 'assets/img/alumni-connect/alumni/alumni14.webp',
            feedback: `ARNI is not only focused on theoretical learning; the faculty is doing its best to increase the practical knowledge of the students as well. They offer live projects, case studies and encourage students to think beyond the textbooks. The hands-on experience I gained here helped me to secure a job in a well-reputed company.`,
        },
        {
            name: 'Geetika Katoch',
            course: 'MBA in HR',
            company: '',
            image: 'assets/img/alumni-connect/alumni/alumni13.webp',
            feedback: `The professors at ARNI are not just teachers; they are mentors who guide you at every step. Their real-world experience and industry insights make learning so much more engaging. Thanks to their career counseling, I was able to choose the right specialization for my MBA!`,
        },
       /* {
            name: 'Varun Sharma',
            course: 'MBA in Finance',
            company: '',
            image: 'https://randomuser.me/api/portraits/men/45.jpg',
            feedback: `Here, I experienced a perfect balance between academics and extracurricular activities. Modern facilities, networking opportunities, healthcare camps, and interactive learning environments have truly shaped my personal and professional growth. I am very proud to be a part of this forward-thinking institution.`,
        },
        {
            name: 'Ritika Dhasmana',
            course: 'MBA',
            company: '',
            image: 'https://randomuser.me/api/portraits/women/44.jpg',
            feedback: `ARNI University has built a strong networking connection with industry giants. They have collaborated with top companies that help students to get internships and training easily. Moreover, they provide grooming sessions to the students so that they can perform well in interviews and get jobs through their placement service cell.`,
        },
        {
            name: 'Naveen',
            course: 'MBA in Marketing',
            company: '',
            image: 'https://randomuser.me/api/portraits/men/46.jpg',
            feedback: `I was always been infatuated with the business world. Thus, I have chosen ARNI’s School of Business Management & Commerce to convert my passion into a profession. The skill-based learning approach, exposure to real-world business challenges, and excellent faculty guidance have prepared me for a promising future!`,
        }*/
    ];
    announcements = [
        {
            date: '05 Nov 2024',
            text: 'Appointment of Dr. Rajneesh Kumar Singh as HOD of Computer Science & Application',
            color: 'bg-green-500'
        },
        {
            date: '05 Nov 2024',
            text: 'Appointment of Dr. Sudeep Varshney as HOD of Computer Science & Engineering',
            color: 'bg-yellow-500'
        },
        {
            date: '22 Aug 2024',
            text: 'Appointment of Prof. (Dr.) Ganesh Gupta as Professor-in-charge of the department',
            color: 'bg-pink-500'
        }
    ];
    departments = [
        {
            name: 'Business Studies',
            icon: 'fa-briefcase',
            branches: [
                'BBA',
                'BBA with Specialization',
                'MBA with Specialization',
                'MBA Retail Management',
                'Ph.D. Management'
            ]
        },
        {
            name: 'Commerce',
            icon: 'fa-chart-line',
            branches: [
                'B.Com',
                'M.Com',
                'Ph.D. Commerce'
            ]
        },
        {
            name: 'Hospitality Management',
            icon: 'fa-concierge-bell',
            branches: [
                'MBA Hospital Management'
            ]
        },
        {
            name: 'Pharmaceutical Management',
            icon: 'fa-pills',
            branches: [
                'MBA Pharmaceutical Management'
            ]
        },
        {
            name: 'Disaster & Risk Management',
            icon: 'fa-exclamation-triangle',
            branches: [
                'Certificate Course on Disaster Risk Reduction and Management',
                'PG Diploma in Disaster Risk Reduction and Management'
            ]
        },
        {
            name: 'Direct Selling & Professional Skills',
            icon: 'fa-handshake',
            branches: [
                'PG Diploma in Direct Selling'
            ]
        }
    ];
    faculties = [
        {
            name: 'Dr. Irshad Ahmad Sofi',
            designation: 'Hod, ARNI School of Business Management and Commerce',
            image: 'assets/img/school-wise-faculties/arni-school-of-business-management-and-commerce/irshad-ahmad-sofi-hod.webp',
        },
        {
            name: 'Ashish Parashar',
            designation: 'Assistant Professor, ARNI School of Business Management and Commerce',
            image: 'assets/img/school-wise-faculties/arni-school-of-business-management-and-commerce/ashish-parashar-assistant-professor.webp',
        },
        {
            name: 'Manu Mahajan',
            designation: 'Assistant Professor, ARNI School of Business Management and Commerce',
            image: 'assets/img/school-wise-faculties/arni-school-of-business-management-and-commerce/manju-mahajan-assistant-professor.webp',
        },
        {
            name: 'Parikalpana Dhiman',
            designation: 'Assistant Professor, ARNI School of Business Management and Commerce',
            image: 'assets/img/school-wise-faculties/arni-school-of-business-management-and-commerce/parikalpana-dhiman-assistant-professor.webp',
        },
        {
            name: 'Rafiq Sheikh',
            designation: 'Assistant Professor, ARNI School of Business Management and Commerce',
            image: 'assets/img/school-wise-faculties/arni-school-of-business-management-and-commerce/rafiq-sheikh-assistant-professor.webp',
        },
        {
            name: 'Ravan Kumar',
            designation: 'Assistant Professor, ARNI School of Business Management and Commerce',
            image: 'assets/img/school-wise-faculties/arni-school-of-business-management-and-commerce/ravan-kumar-assistant-professor.webp',
        },
        {
            name: 'Rohit Pathania',
            designation: 'Assistant Professor, ARNI School of Business Management and Commerce',
            image: 'assets/img/school-wise-faculties/arni-school-of-business-management-and-commerce/rohit-pathania-assistant-professor.webp',
        },
        {
            name: 'Shashi Karel',
            designation: 'Assistant Professor, ARNI School of Business Management and Commerce',
            image: 'assets/img/school-wise-faculties/arni-school-of-business-management-and-commerce/shashi-karel-assistant-professor.webp',
        },
    ];
    recruiters = [
        { name: "Adani Wilmar", logo: "assets/img/companies/adani_wilmar.png" },
        { name: "Amar Ujala", logo: "assets/img/companies/amarujala.png" },
        { name: "Amazon", logo: "assets/img/companies/Amazon.png" },
        { name: "CMC", logo: "assets/img/companies/cmc-logo_0.png" },
        { name: "Dish TV", logo: "assets/img/companies/Dish_TV_2.png" },
        { name: "Future Group", logo: "assets/img/companies/FutureGroup.png" },
        { name: "HCL", logo: "assets/img/companies/hcl.png" },
        { name: "ICICI", logo: "assets/img/companies/icici_securities.png" },
        { name: "Sleepwell", logo: "assets/img/companies/sleepwell.png" },
        { name: "SYNTEL", logo: "assets/img/companies/syntel2.png" },
        {
            name: "Tech Mahindra",
            logo: "assets/img/companies/Tech_Mahindra_New_Logo1.png",
        },
        { name: "Vodafone", logo: "assets/img/companies/Vodafone_logo.png" },
        { name: "Zee TV", logo: "assets/img/companies/Zee_TV_2011.png" },
        { name: "Genpact", logo: "assets/img/companies/zenpact.png" },
        { name: "Reliance", logo: "assets/img/companies/amarujala.png" },
    ];

    nextSlide() {
        if (this.index < this.recruiters.length - 3) {
            this.index++;
        }
    }

    prevSlide() {
        if (this.index > 0) {
            this.index--;
        }
    }

    constructor(
        private meta: Meta,
        private titles: Title,
        private router: Router
    ) {}

    ngOnInit(): void {
        window.scrollTo(0, 0);
        this.updateMetaTags();
        this.scrollToContent();
        this.groupTestimonials();
    }

    @HostListener('window:resize')
    onResize() {
        this.groupTestimonials();
    }

    groupTestimonials(): void {
        const screenWidth = window.innerWidth;
        let perSlide = 1;
        if (screenWidth >= 1024) {
            perSlide = 3;
        } else if (screenWidth >= 768) {
            perSlide = 2;
        } else {
            perSlide = 1;
        }
        const grouped = [];
        for (let i = 0; i < this.testimonials.length; i += perSlide) {
            grouped.push(this.testimonials.slice(i, i + perSlide));
        }
        this.groupedTestimonials = grouped;
        if (this.testimonialSlideIndex >= this.groupedTestimonials.length) {
            this.testimonialSlideIndex = 0;
        }
    }

    scrollToContent() {
        const tabs = document.querySelectorAll('.tab-link');
        const tabContainer = document.querySelector('.tab-buttons');
        const header = document.querySelector('header');

        const tabHeight = tabContainer?.getBoundingClientRect().height || 0;
        const headerHeight = header?.getBoundingClientRect().height || 0;

        const totalOffset = tabHeight + headerHeight + 15;

        tabs.forEach(tab => {
            tab.addEventListener('click', (event: Event) => {
                event.preventDefault();

                tabs.forEach(t => t.classList.remove('active-tab'));
                (event.target as HTMLElement).classList.add('active-tab');

                const targetId = (event.target as HTMLElement).getAttribute('href')?.substring(1);
                if (targetId) {
                    const targetElement = document.getElementById(targetId);
                    if (targetElement) {
                        const y = targetElement.getBoundingClientRect().top + window.pageYOffset - totalOffset;
                        window.scrollTo({ top: y, behavior: 'smooth' });
                    }
                }
            });
        });
    }

    goTo(url: string) {
        this.router.navigateByUrl(url);
    }

    prev() {
        if (this.currentIndex > 0) {
            this.currentIndex--;
            this.translateX = -this.currentIndex * 25; // Move 25% left
        }
    }

    next() {
        if (this.currentIndex < this.faculties.length - 1) {
            this.currentIndex++;
            this.translateX = -this.currentIndex * 25; // Move 25% right
        }
    }

    setTestimonialSlide(index: number) {
        this.testimonialSlideIndex = index;
    }

    updateMetaTags() {
        this.titles.setTitle('Undergraduate Courses for Science Students at ARNI School');
        this.meta.updateTag({
            name: 'description',
            content: `Explore undergraduate courses for science students at ARNI School of Technology. Prepare for a successful career with a top-tier education and hands-on experience.`
        });
    }
}
